<div class="admin-container">
  <div class="card border-0 p-3">
    <app-grid-table
      [data]="rows"
      [columns]="columns"
      [title]="'admin.contacts.table.title' | translate"
      detailsBaseRoute="/admin/contacts"
      [loading]="isLoading()"
    >
      <app-button
        actions
        type="button"
        iconClass="fas fa-plus"
        label="Add"
        btnClass="btn btn-primary btn-sm "
        (clicked)="openAddModal()"
      ></app-button>
    </app-grid-table>
  </div>
</div>

<app-add-contact-modal
  [open]="showAddModal()"
  [title]="'Add Contact'"
  (close)="closeAddModal()"
  (submit)="handleAdd($event)"
></app-add-contact-modal>
